export default __webpack_public_path__ + "static/media/472.07c126aa.gif";